//kpi-row.ts

export type KpiDirection = 'up' | 'down' | 'flat';

export interface KpiCardVm {
    id: string;
    title: string;
    value: number | string;
    trendText?: string;
    direction?: KpiDirection;
    isClickable?: boolean;
    active?: boolean;
}

export class KpiRow {
    private container: JQuery;
    private readonly visibleCount = 5;
    private scrollInterval?: number;
    private rotationIndex = 0;
    private isAnimating = false;


    constructor(
        containerSelector: string,
        private onActionClick: (id: string) => void
    ) {
        this.container = $(containerSelector);
        if (!this.container.length) {
            console.warn(`KpiRow: container not found for ${containerSelector}`);
        }
    }
    //Determine carousel or row
    render(cards: KpiCardVm[]) {
        this.destroyScroller();

        if (cards.length > this.visibleCount) {
            this.container.html(this.renderCarousel(cards));
            this.initScroller();
        } else {
            this.container.html(this.renderStandardRow(cards));
        }
    }

    private renderStandardRow(cards: KpiCardVm[]): string {
        return `
        <div class="kpi-standard-row">
            ${cards.map(c => `
                <div class="kpi-standard-item">
                    ${this.renderCardBody(c)}
                </div>
            `).join('')}
        </div>
    `;
    }

    private renderCarousel(cards: KpiCardVm[]): string {
        return `
        <div class="kpi-scroller">
            <div class="kpi-scroller-viewport">
                <div class="kpi-scroller-track">
                    ${cards.map(c => `
                        <div class="kpi-scroller-item">
                            ${this.renderCardBody(c)}
                        </div>
                    `).join('')}
                </div>
            </div>

            <div class="kpi-carousel-indicators">
                ${cards.map((_, i) => `
                    <span class="kpi-dot ${i === 0 ? 'active' : ''}" data-index="${i}"></span>
                `).join('')}
            </div>
        </div>
    `;
    }
    private renderCardBody(c: KpiCardVm): string {
        return `
    <div class="kpi-card ${c.active ? 'kpi-card-active' : ''}" data-id="${c.id}">
        
        <div class="js-card-header d-flex justify-content-between align-items-start">
            <div class="kpi-title">${c.title}</div>

           
        </div>

        <div class="kpi-count">${c.value}</div>

        <div class="kpi-footer d-flex justify-content-between align-items-end">
            <span class="kpi-change">
                ${this.getTrendHtml(c)}
            </span>

            ${c.isClickable ? `
                <button class="${c.active ? 'clear-btn' : 'view-btn'} kpi-btn btn-sm"
                        data-id="${c.id}">
                    ${c.active ? 'Clear' : 'View'}
                </button>
            ` : ''}
        </div>
    </div>
    `;
    }
 
    private initScroller(): void {
        const $track = this.container.find('.kpi-scroller-track');
        const $items = this.container.find('.kpi-scroller-item');
        if (!$track.length || !$items.length) return;

        this.rotationIndex = 0;
        this.isAnimating = false;

        $track.css({
            transition: 'none',
            transform: 'translateX(0px)'
        });

        this.updateDots();

        this.scrollInterval = window.setInterval(() => {
            this.moveNext();
        }, 4200);
    }
    private moveNext(): void {
        if (this.isAnimating) return;

        const $track = this.container.find('.kpi-scroller-track');
        const $first = $track.find('.kpi-scroller-item').first();

        if (!$track.length || !$first.length) return;

        const itemWidth = ($first[0] as HTMLElement).getBoundingClientRect().width;
        this.isAnimating = true;

        $track.css({
            transition: 'transform 600ms ease',
            transform: `translateX(-${itemWidth}px)`
        });

        $track.off('transitionend.kpi').on('transitionend.kpi', () => {
            $track.off('transitionend.kpi');

            $track.append($first);
            $track.css({
                transition: 'none',
                transform: 'translateX(0px)'
            });

            this.rotationIndex = (this.rotationIndex + 1) % this.getDotCount();
            this.updateDots();

            this.isAnimating = false;
        });
    }
    private getDotCount(): number {
        return this.container.find('.kpi-dot').length;
    }

    private updateDots(): void {
        const $dots = this.container.find('.kpi-dot');
        $dots.removeClass('active');
        $dots.eq(this.rotationIndex).addClass('active');
    }
  
    private getTrendHtml(c: KpiCardVm): string {
        if (!c.trendText) return '';

        if (c.direction === 'up') {
            return `<i class="fas fa-caret-up mr-1 kpi-up"></i>${c.trendText}`;
        }

        if (c.direction === 'down') {
            return `<i class="fas fa-caret-down mr-1 kpi-down"></i>${c.trendText}`;
        }

        return c.trendText;
    }

    wireEvents(): void {
        this.container
            .off('click.kpiAction', '.kpi-btn')
            .on('click.kpiAction', '.kpi-btn', (e) => {
                e.preventDefault();

                const id = String($(e.currentTarget).attr('data-id') || '').trim();
                if (!id) return;

                this.onActionClick(id);
            });
    }
  
    private destroyScroller(): void {
        if (this.scrollInterval) {
            window.clearInterval(this.scrollInterval);
            this.scrollInterval = undefined;
        }

        this.container.find('.kpi-scroller-track').off('transitionend.kpi');
        this.isAnimating = false;
    }
 
}